/**
 * Build the /missions URL for a given mission, pre-filling the search bar with
 * the numeric `id_mission` so the targeted mission also appears in the list.
 *
 * Accepts any mission-shaped object with at least `_id` (or `id`) and optionally
 * `id_mission`.
 */
export const buildMissionDetailHref = (mission) => {
  if (!mission) return null;
  const rawId = mission._id ?? mission.id;
  if (!rawId) return null;
  const missionId = typeof rawId === 'string' ? rawId : String(rawId);
  const params = new URLSearchParams({ mission: missionId });
  if (mission.id_mission) params.set('search', String(mission.id_mission));
  return `/missions?${params.toString()}`;
};
